import {
  ChangeDetectionStrategy,
  Component,
  OnInit,
  TemplateRef,
  ViewChild,
  Inject,
  AfterViewInit,
  ElementRef,
} from '@angular/core';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { SelectionModel } from '@angular/cdk/collections';
import {
  FormBuilder,
  FormGroup,
  FormControl,
  Validators,
} from '@angular/forms';
import { Lightbox } from 'ng-gallery/lightbox';
import { UserManagementService } from 'src/app/Service/user-management.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import { MatSort, Sort } from '@angular/material/sort';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { MatChipInputEvent } from '@angular/material/chips';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatDialog } from '@angular/material/dialog';
import * as moment from 'moment';
import { RemarkPopupComponent } from 'src/app/modals/remark-popup/remark-popup.component';

export interface Element {
  schemtTitle: number;
  description: string;
  dateposted: string;
  categoryName: string;
  attachLink: string;
  attachedFile: string;
  action: string;
}

@Component({
  selector: 'app-govt-schemes-list',
  templateUrl: './govt-schemes-list.component.html',
  styleUrls: ['./govt-schemes-list.component.scss'],
})
export class GovtSchemesListComponent implements OnInit {
  form = new FormGroup({
    start: new FormControl(),
    end: new FormControl(),
  });

  filtershow = true;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  selectable = true;
  removable = true;
  addOnBlur = true;
  readonly separatorKeysCodes = [ENTER, COMMA] as const;
  fruits: any = [];
  reg =
    '^(https?://)?(www\\.)?([-a-z0-9]{1,63}\\.)*?[a-z0-9][-a-z0-9]{0,61}[a-z0-9]\\.[a-z]{2,6}(/[-\\w@\\+\\.~#\\?&/=%]*)?$';
  /* Mat chip input */
  public matChipArray = [];

  displayedColumns = [
    'dateposted',
    'schemtTitle',
    'categoryName',
    'attachLink',
    'attachedFile',
    'updatedBy',
    'action',
  ];

  dataSource = new MatTableDataSource<Element>([]);

  avgCount: any = [];
  totalCount;

  userdata;
  GovernmentSchemes = [];
  GovernmentSchemesList;

  selectedSorting: string;
  selectFilterData1;
  selectFilterData;
  searchData;
  filterbyText = '';
  exportcsvdata = false;
  formhide = false;
  formedit: FormGroup;
  filterbycategoryname = '';
  categoryname = '';
  filterbyformdate = '';
  formdate = '';
  filterbytodayte = '';
  todayte = '';
  //sorting table
  dataSourcelist;
  @ViewChild(MatSort) sort: MatSort;
  isButtonVisible = false;
  lastFilePath: any;

  datepicker = [
    {
      value: '0',
      viewValue: '1 Week',
      startDate: new Date(new Date().setDate(new Date().getDate() - 7)),
      endDate: new Date(),
    },
    {
      value: '1',
      viewValue: '1 Months',
      startDate: new Date(new Date().setDate(new Date().getDate() - 30)),
      endDate: new Date(),
    },
    {
      value: '2',
      viewValue: '3 Months',
      startDate: new Date(new Date().setDate(new Date().getDate() - 90)),
      endDate: new Date(),
    },
    {
      value: '3',
      viewValue: '6 Months',
      startDate: new Date(new Date().setDate(new Date().getDate() - 180)),
      endDate: new Date(),
    },
    {
      value: '4',
      viewValue: '1 Year',
      startDate: new Date(new Date().setDate(new Date().getDate() - 365)),
      endDate: new Date(),
    },
  ];

  ranges: any = {
    '1 Week': [moment().subtract(6, 'days'), moment()],
    '1 Month': [moment().subtract(29, 'days'), moment()],
    '3 Months': [moment().subtract(59, 'days'), moment()],
    '6 Months': [moment().subtract(179, 'days'), moment()],
    '1 Year': [moment().subtract(364, 'days'), moment()],
  };

  constructor(
    private router: Router,
    public toastr: ToastrService,
    private fb: FormBuilder,
    private spinner: NgxSpinnerService,
    public lightbox: Lightbox,
    public _userService: UserManagementService,
    private datePipe: DatePipe,
    public dialog: MatDialog
  ) {}

  ngOnInit(): void {
    this.formedit = this.fb.group({
      id: [''],
      SchemtTitle: [
        '',
        [Validators.required, Validators.pattern(/^(\s+\S+\s*)*(?!\s).*$/)],
      ], //mandatory include document Attchment
      DatePosted: [],
      Description: [
        '',
        [Validators.required, Validators.pattern(/^(\s+\S+\s*)*(?!\s).*$/)],
      ], //500 character (optional)
      CategoryID: ['', [Validators.required]], //mandatory
      Attachedlink: ['', [Validators.pattern(this.reg)]],
      //Remark: ['', [Validators.required]],
    });

    this.spinner.show();
    setTimeout(() => {
      this.spinner.hide();
    }, 4000);

    this.governmentSchemes();
    this.GetTotalCount();
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
  }

  governmentSchemes() {
    this.spinner.show();
    var postdata = {
      search: '',
      fromDate: '',
      todate: '',
      pageNumber: 0,
    };

    this._userService.getGovernmentSchemes(postdata).subscribe((data) => {
      this.GovernmentSchemesList = data;
      this.paginationProperty = this.GovernmentSchemesList.result.data;
      this.length = this.paginationProperty.totalItems;
      this.previousPageIndex = this.paginationProperty.previousPageIndex;
      this.hasNextPage = this.paginationProperty.hasNextPage;
      this.hasPreviousPage = this.paginationProperty.hasPreviousPage;
      this.pageIndex = this.paginationProperty.pageNumber;
      this.totalPages = this.paginationProperty.totalPages;
      this.dataSource = new MatTableDataSource<Element>(
        this.GovernmentSchemesList.result.data.list
      );
      this.dataSource.sort = this.sort;
      this.spinner.hide();
    });
  }
  GetTotalCount() {
    this._userService.getGovernmentSchemeTotalCount().subscribe((data) => {
      this.totalCount = data;
      this.avgCount = this.totalCount.result.data;
    });
  }

  /*======================================== Paginator ========================================================== */
  /*......................Pagination.................*/
  paginationProperty;
  hasNextPage;
  hasPreviousPage;
  nextPageNumber;
  pageNumber;
  pageSize;
  previousPageNumber;
  totalItems;
  totalPages;
  pageEvent: PageEvent;
  datasource: null;
  pageIndex: number;
  length: number;
  previousPageIndex;
  pagechangeevent;
  searchText = '';
  searchDate = '';

  public getServerData(event?: PageEvent) {
    this.pagechangeevent = event;
    this.pageIndex = this.pagechangeevent.pageIndex;
    this.length = this.pagechangeevent.length;
    this.pageSize = this.pagechangeevent.pageSize;

    if (this.exportcsvdata == true) {
      var postdata = {
        fromDate: this.filterbyformdate,
        todate: this.filterbytodayte,
        search: this.filterbyText,
        categoryName: this.filterbycategoryname,
        pageNumber: this.pageIndex,
        pageSize: this.pageSize,
      };
      this._userService.getGovernmentSchemes(postdata).subscribe((data) => {
        this.userdata = data;
        this.GovernmentSchemesList = this.userdata.result.data.list;
        this.paginationProperty = this.userdata.result.data;
        this.length = this.paginationProperty.totalItems;
        this.previousPageIndex = this.paginationProperty.previousPageIndex;
        this.hasNextPage = this.paginationProperty.hasNextPage;
        this.hasPreviousPage = this.paginationProperty.hasPreviousPage;
        this.pageIndex = this.paginationProperty.pageNumber;

        this.dataSource = new MatTableDataSource(this.GovernmentSchemesList);
        this.dataSource.sort = this.sort;
        //  this.dataSource.paginator = this.paginator;
        this.spinner.hide();
      });
    } else {
      var postdata = {
        fromDate: '',
        todate: '',
        search: '',
        categoryName: '',
        pageNumber: this.pageIndex,
        pageSize: this.pageSize,
      };
      this._userService.getGovernmentSchemes(postdata).subscribe((data) => {
        this.userdata = data;
        this.GovernmentSchemesList = this.userdata.result.data.list;
        this.paginationProperty = this.userdata.result.data;
        this.length = this.paginationProperty.totalItems;
        this.previousPageIndex = this.paginationProperty.previousPageIndex;
        this.hasNextPage = this.paginationProperty.hasNextPage;
        this.hasPreviousPage = this.paginationProperty.hasPreviousPage;
        this.pageIndex = this.paginationProperty.pageNumber;
        this.dataSource = new MatTableDataSource(this.GovernmentSchemesList);
        this.dataSource.sort = this.sort;
        this.spinner.hide();
      });
    }
  }

  /*======================================== Paginator ========================================================== */

  /*=========================================== apply filter ======================================================================== */
  startdata;
  enddata;
  sharedate;
  onDateRangeChanged(dates) {
    this.sharedate = dates;
    if (dates) {
      this.enddata = dates.endDate
        ? this.datePipe.transform(dates.endDate, 'yyyy/MM/dd hh:mm:ss')
        : null;
      this.startdata = dates.startDate
        ? this.datePipe.transform(dates.startDate, 'yyyy/MM/dd hh:mm:ss')
        : null;
    }
  }

  filterbysharedate;
  applyfilter(checkEmpty) {
    if (
      checkEmpty &&
      !this.searchData &&
      !this.categoryname &&
      !this.sharedate.endDate &&
      !this.sharedate.startDate
    ) {
      alert('Please provide input first');
    } else {
      this.exportcsvdata = true;
      this.filterbyText = this.searchData;
      this.filterbycategoryname = this.categoryname;
      this.filterbysharedate = this.sharedate;
      this.filterbyformdate = this.enddata;
      this.filterbytodayte = this.startdata;

      let indexcategoryname = this.matChipArray.findIndex(
        (x) => x.tag === 'categoryname'
      );
      let indexformdate = this.matChipArray.findIndex(
        (x) => x.tag === 'formdate'
      );
      let indextodayte = this.matChipArray.findIndex(
        (x) => x.tag === 'todayte'
      );
      let indexsharedate = this.matChipArray.findIndex(
        (x) => x.tag === 'sharedate'
      );

      if (this.categoryname != '') {
        if (indexcategoryname > -1) {
          this.matChipArray[indexcategoryname].name =
            'Category Name' + ':' + this.categoryname;
        } else {
          if (this.categoryname != '' && this.categoryname != undefined) {
            this.matChipArray.push({
              name: 'Category Name' + ':' + this.categoryname,
              tag: 'categoryname',
              flag: true,
            });
          }
        }
      }

      if (this.sharedate && this.startdata && this.enddata) {
        if (indexsharedate > -1) {
          this.matChipArray[indexsharedate].name =
            'Shared date' +
            ':' +
            (this.sharedate['startDate']
              ? this.sharedate['startDate'].format('MM/DD/YYYY')
              : '') +
            ' to ' +
            (this.sharedate['endDate']
              ? this.sharedate['endDate'].format('MM/DD/YYYY')
              : '');
        } else {
          this.matChipArray.push({
            name:
              'Shared date' +
              ':' +
              (this.sharedate['startDate']
                ? this.sharedate['startDate'].format('MM/DD/YYYY')
                : '') +
              ' to ' +
              (this.sharedate['endDate']
                ? this.sharedate['endDate'].format('MM/DD/YYYY')
                : ''),
            tag: 'sharedate',
            flag: true,
          });
        }
      }

      var postdata = {
        fromDate: this.startdata,
        toDate: this.enddata,
        search: this.filterbyText,
        categoryName: this.filterbycategoryname,
        pageNumber: 0,
        pageSize: 10,
      };
      this._userService.getGovernmentSchemes(postdata).subscribe((data) => {
        this.userdata = data;
        this.GovernmentSchemesList = this.userdata.result.data.list;
        this.paginationProperty = this.userdata.result.data;
        this.length = this.paginationProperty.totalItems;
        this.previousPageIndex = this.paginationProperty.previousPageIndex;
        this.hasNextPage = this.paginationProperty.hasNextPage;
        this.hasPreviousPage = this.paginationProperty.hasPreviousPage;
        this.pageIndex = this.paginationProperty.pageNumber;
        this.dataSource = new MatTableDataSource(this.GovernmentSchemesList);
        this.dataSource.sort = this.sort;
        //  this.dataSource.paginator = this.paginator;
        this.spinner.hide();
      });
    }
  }
  remove(index, tag): void {
    if (tag === 'categoryname') {
      this.matChipArray.splice(index, 1);
      this.categoryname = '';
    }
    if (tag === 'sharedate') {
      this.matChipArray.splice(index, 1);
      this.sharedate = undefined;
    }
    setTimeout(() => {
      this.applyfilter(false);
    }, 500);
  }

  changeFn(event: any) {
    if (event.isTrusted == true) {
      this.applyfilter(false);
    }
  }

  /*=========================================== apply filter ======================================================================== */
  /*=================================================== Export Csv =============================================================================== */
  /*Export csv file */
  apidata;
  maindata;
  filename;

  exportcsv() {
    if (this.exportcsvdata == true) {
      this.applyfilter(false);
      var postdata = {
        fromDate: this.filterbyformdate,
        toDate: this.filterbytodayte,
        search: this.filterbyText,
        categoryname: this.filterbycategoryname,
      };
      this._userService.getAllUsergovtpdf(postdata).subscribe((data) => {
        this.apidata = data;
        const blob = new Blob([this.apidata], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });
        const url = window.URL.createObjectURL(blob);
        var anchor = document.createElement('a');
        anchor.download = 'PKF_Govtlist.xlsx';
        anchor.href = url;
        anchor.click();
        // window.open(url);
      });
    } else {
      var postdata = {
        fromDate: this.filterbyformdate,
        toDate: this.filterbytodayte,
        search: this.filterbyText,
        categoryname: this.filterbycategoryname,
      };
      this._userService.getAllUsergovtpdf(postdata).subscribe((data) => {
        this.apidata = data;
        const blob = new Blob([this.apidata], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });
        const url = window.URL.createObjectURL(blob);
        // window.open(url);
        var anchor = document.createElement('a');
        anchor.download = 'PKF_Govtlist.xlsx';
        anchor.href = url;
        anchor.click();
      });
    }
  }

  openRemarkDialog() {
    const dialogRef = this.dialog.open(RemarkPopupComponent, {});
    return dialogRef;
  }

  /*===================================================== Column Based Export File =========================================  */

  dialogresult;
  mainresult;
  openDialogexport(): void {
    const dialogRef = this.dialog.open(GovtSchemesExport, {
      width: '60%',
      height: '60%',
      //  data: {id: data}
    });
    dialogRef.afterClosed().subscribe((result) => {
      this.dialogresult = result;
      //================================REPORT GENERATE==========================================//
      if (this.dialogresult != undefined) {
        this.mainresult = JSON.parse(this.dialogresult.data);
        if (this.mainresult.length != 0) {
          let Result = this.mainresult.map((choice) => choice.value);
          let text = confirm('Are you sure you want to export this file?');
          if (text == true) {
            if (this.exportcsvdata == true) {
              this.applyfilter(false);
              var postdata = {
                fromDate: this.startdata,
                toDate: this.enddata,
                search: this.filterbyText,
                categoryName: this.filterbycategoryname,
                reportKeyList: Result,
              };
              this._userService
                .getGovernmentSchemesReports(postdata)
                .subscribe((data) => {
                  this.apidata = data;
                  const blob = new Blob([this.apidata], {
                    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                  });
                  const url = window.URL.createObjectURL(blob);
                  var anchor = document.createElement('a');
                  anchor.download = 'PKF_GovtScheme';
                  anchor.href = url;
                  anchor.click();
                });
            } else {
              postdata = {
                fromDate: '',
                toDate: '',
                search: '',
                categoryName: '',
                reportKeyList: Result,
              };

              this._userService
                .getGovernmentSchemesReports(postdata)
                .subscribe((data) => {
                  this.apidata = data;
                  const blob = new Blob([this.apidata], {
                    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                  });
                  const url = window.URL.createObjectURL(blob);
                  // window.open(url);
                  var anchor = document.createElement('a');
                  anchor.download = 'PKF_GovtScheme.xlsx';
                  anchor.href = url;
                  anchor.click();
                });
            }
          } else {
            this.openDialogexport();
          }
        } else {
          alert('Please select atleast any one columns to generate report!');
          this.openDialogexport();
        }
      }
    });
  }
  /*=================================================== Export Csv =============================================================================== */
  formPage() {
    this.router.navigate(['/Govt-schemes']);
  }

  clearFilter() {
    this.spinner.show();
    window.location.reload();
  }

  openLink(url) {
    window.open(url, '_blank');
  }
  categorydata;
  categorydatalist;
  categoryId;
  getcategoryId(id) {
    this.categoryId = id;
  }
  attachfile;
  edit(readdata) {
    this.formhide = true;

    this._userService.getCategorylist().subscribe((data) => {
      this.categorydata = data;
      this.categorydatalist = this.categorydata.result.data;
    });

    this.formedit.get('SchemtTitle').setValue(readdata.schemtTitle);
    this.formedit.get('Description').setValue(readdata.description);
    this.formedit.get('CategoryID').setValue(readdata.categoryName);
    this.formedit.get('Attachedlink').setValue(readdata.attachLink);
    this.formedit.get('id').setValue(readdata.id);
    this.attachfile = readdata.attachedFile;
  }

  listPage() {
    this.formhide = false;
  }

  fileData;
  finaldata;

  file1: File;
  @ViewChild('inputFile') myInputVariable: ElementRef;
  processImage(event) {
    this.isButtonVisible = true;
    // let files: FileList = event.target.files;
    // this.file1  = files[0];
    let splitfile = event.target.files[0].type;
    let type = splitfile.split('/');

    if (
      type[1] == 'jpeg' ||
      type[1] == 'jpg' ||
      type[1] == 'png' ||
      type[1] == 'pdf'
    ) {
      this.finaldata = this.file1;
      this.savescheme = true;
    } else {
      this.finaldata = 0;
      this.myInputVariable.nativeElement.value = '';
      this.savescheme = false;
      this.isButtonVisible = false;
      this.toastr.warning(
        'Accepted File Formats PDF,PNG.JPG and JPEG only',
        'Info',
        {
          timeOut: 3000,
        }
      );
      return;
    }

    this.lastFilePath = this.myInputVariable.nativeElement.value;
    let files: FileList = event.target.files;
    this.file1 = files[0];

    if (this.file1.size >= 1572864) {
      this.myInputVariable.nativeElement.value = '';
      this.toastr.warning('Accepted File Size should be below 5MB', 'Info', {
        timeOut: 3000,
      });
    } else {
      this.finaldata = this.file1;
      this.savescheme = true;
    }
  }

  savescheme = false;
  descriptionchange(data) {
    if (data.length != 0) {
      this.savescheme = true;
    } else {
      this.savescheme = false;
    }
  }

  // postdata; iddata; response;
  // onSubmit() {
  //   // if (this.formedit.value.Attachedlink != '') {
  //   //   var pattern = new RegExp(this.reg);
  //   //   var result = pattern.test(this.form.value.Attachedlink);
  //   //   if (result == false) {
  //   //     alert('Please enter valid attachedlink.')
  //   //     return false
  //   //   }
  //   // }
  //   if(this.formedit.value.Attachedlink == undefined)
  //   if (this.formedit.valid) {
  //     let myfile = this.finaldata
  //     const postdata = new FormData();
  //     postdata.append('SchemtTitle', this.formedit.value.SchemtTitle);
  //     postdata.append('GovSchemeID', this.formedit.value.id);
  //     postdata.append('Description', this.formedit.value.Description);
  //     postdata.append('CategoryID', this.formedit.value.categoryId == undefined ? '' : this.formedit.value.categoryId);
  //     postdata.append('AttachLink', this.formedit.value.Attachedlink == undefined ? '' : this.formedit.value.Attachedlink);
  //     postdata.append('Remark', this.formedit.value.Remark);
  //     postdata.append('AttachedFileUpload', this.finaldata == undefined ? '' : this.finaldata);
  //     postdata.append('CategoryName', "");
  //     postdata.append('DatePosted', "");
  //     postdata.append('AttachedFile', "");

  //     this.iddata = this.formedit.value.id;

  //     if (confirm("Are you sure you want to publish this Goverment Scheme updates?")) {
  //      this._userService.updateGovernmentSchemes(postdata).subscribe(data => {
  //      this.response = data;
  //      this.spinner.hide()
  //      this.toastr.success(this.response.result.message, 'Success', {
  //        timeOut: 3000,
  //      });

  //    });
  //  }
  //     this.router.navigateByUrl('', { skipLocationChange: true }).then(() => {
  //       this.router.navigate(['/Govt-schemes-list']);
  //       this.spinner.hide();
  //     });

  //   } else {
  //     alert("Please fill all mandatory fields and enter valid values")
  //   }

  // }
  postdata;
  iddata;
  response;
  onSubmit() {
    // if (this.formedit.value.Attachedlink != '') {
    // var pattern = new RegExp(this.reg);
    // var result = pattern.test(this.form.value.Attachedlink);
    // if (result == false) {
    // alert('Please enter valid attachedlink.')
    // return false
    // }
    // }
    let x;
    const ref = this.openRemarkDialog();
    ref.afterClosed().subscribe((result) => {
      x = result;
      // if (this.formedit.value.Attachedlink == undefined)

      if (this.formedit.valid && x) {
        let myfile = this.finaldata;
        const postdata = new FormData();
        postdata.append('SchemtTitle', this.formedit.value.SchemtTitle);
        postdata.append('GovSchemeID', this.formedit.value.id);
        postdata.append('Description', this.formedit.value.Description);
        postdata.append(
          'CategoryID',
          this.formedit.value.categoryId == undefined
            ? ''
            : this.formedit.value.categoryId
        );
        postdata.append(
          'AttachLink',
          this.formedit.value.Attachedlink == undefined
            ? ''
            : this.formedit.value.Attachedlink
        );
        postdata.append('Remark', x);
        postdata.append(
          'AttachedFileUpload',
          this.finaldata == undefined ? '' : this.finaldata
        );
        postdata.append('CategoryName', '');
        postdata.append('DatePosted', '');
        postdata.append('AttachedFile', '');

        this.iddata = this.formedit.value.id;

        // if (confirm("Are you sure you want to publish this Goverment Scheme updates?")) {
        this._userService
          .updateGovernmentSchemes(postdata)
          .subscribe((data) => {
            this.response = data;
            this.spinner.hide();
            this.toastr.success(this.response.result.message, 'Success', {
              timeOut: 3000,
            });
          });
        // }
        this.router.navigateByUrl('', { skipLocationChange: true }).then(() => {
          this.router.navigate(['/Govt-schemes-list']);
          this.spinner.hide();
        });
      }
      // else {
      //   alert("Please fill all mandatory fields and enter valid values")
      // }
    });
  }
  /*model pop up same page  */
  openDialog(data): void {
    const dialogRef = this.dialog.open(DeletPopUp, {
      // width: '30%',
      // height: '30%',
      data: { id: data },
    });

    dialogRef.afterClosed().subscribe((result) => {
      this.applyfilter(false);
      this.GetTotalCount();
    });
  }
  /*model pop up same page  */
}
/* */
@Component({
  selector: 'delet-pop-up',
  templateUrl: 'delet-pop-up.html',
})
export class DeletPopUp {
  formdelet: FormGroup;
  response;
  constructor(
    public dialogRef: MatDialogRef<DeletPopUp>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    public _userService: UserManagementService,
    public toastr: ToastrService,
    private router: Router
  ) {}
  onNoClick(): void {
    this.dialogRef.close();
  }
  ngOnInit(): void {
    this.formdelet = this.fb.group({
      Remark: ['', [Validators.required]],
    });
  }
  onSubmit() {
    if (this.formdelet.valid) {
      var postdata = {
        govSchemeID: this.data.id,
        remark: this.formdelet.value.Remark,
      };
      this._userService.removegovtdata(postdata).subscribe((data) => {
        this.response = data;
        // window.location.reload();
        this.toastr.success(this.response.result.message, 'Success', {
          timeOut: 3000,
        });
        this.dialogRef.close();
      });
    } else {
      alert('Please enter valid remark !');
      return false;
    }
  }
}

@Component({
  selector: 'govt-schemes-export',
  templateUrl: 'govt-schemes-export.html',
})
export class GovtSchemesExport {
  response;
  title = 'Select/ Unselect All Checkboxes';
  masterSelected: boolean;
  checklist: any;
  checkedList: any;
  constructor(
    public dialogRef: MatDialogRef<GovtSchemesExport>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    public _userService: UserManagementService,
    public toastr: ToastrService,
    private router: Router
  ) {
    this.masterSelected = false;
    this.checklist = [
      {
        id: 1,
        viewValue: 'Category Name',
        value: 'CategoryName',
        isSelected: false,
      },
      {
        id: 2,
        viewValue: 'Scheme Title',
        value: 'SchemtTitle',
        isSelected: false,
      },
      {
        id: 3,
        viewValue: 'Description',
        value: 'Description',
        isSelected: false,
      },
      {
        id: 4,
        viewValue: 'Posted Date',
        value: 'Dateposted',
        isSelected: false,
      },
      {
        id: 5,
        viewValue: 'Attached File',
        value: 'AttachedFile',
        isSelected: false,
      },
      {
        id: 6,
        viewValue: 'Attach Link',
        value: 'AttachLink',
        isSelected: false,
      },
      { id: 7, viewValue: 'Created By', value: 'CreatedBy', isSelected: false },
    ];
    this.getCheckedItemList();
  }
  //  onNoClick(): void {
  //   // this.dialogRef.close();
  //  }
  ngOnInit(): void {
    // this.getCheckedItemList();
  }

  // The master checkbox will check/ uncheck all items
  checkUncheckAll() {
    for (var i = 0; i < this.checklist.length; i++) {
      this.checklist[i].isSelected = this.masterSelected;
    }
    this.getCheckedItemList();
  }

  // Check All Checkbox Checked
  isAllSelected() {
    this.masterSelected = this.checklist.every(function (item: any) {
      return item.isSelected == true;
    });
    this.getCheckedItemList();
  }
  // Get List of Checked Items
  getCheckedItemList() {
    this.checkedList = [];
    for (var i = 0; i < this.checklist.length; i++) {
      if (this.checklist[i].isSelected)
        this.checkedList.push(this.checklist[i]);
    }
    this.checkedList = JSON.stringify(this.checkedList);
  }
  closeDialog() {
    this.dialogRef.close({ data: this.checkedList });
  }
  closeDialogtest() {
    this.dialogRef.close();
  }
}
